import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 9.03757 2.96243 11.5 6 11.5C9.03757 11.5 11.5 9.03757 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5ZM5.25 4.5C5.25 4.22386 5.02614 4 4.75 4C4.47386 4 4.25 4.22386 4.25 4.5V7.5C4.25 7.77614 4.47386 8 4.75 8C5.02614 8 5.25 7.77614 5.25 7.5V4.5ZM7.75 4.5C7.75 4.22386 7.52614 4 7.25 4C6.97386 4 6.75 4.22386 6.75 4.5V7.5C6.75 7.77614 6.97386 8 7.25 8C7.52614 8 7.75 7.77614 7.75 7.5V4.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.99996 0.666992C3.94987 0.666992 0.666626 3.95024 0.666626 8.00033C0.666626 12.0504 3.94987 15.3337 7.99996 15.3337C12.05 15.3337 15.3333 12.0504 15.3333 8.00033C15.3333 3.95024 12.05 0.666992 7.99996 0.666992ZM6.99996 6.00033C6.99996 5.63214 6.70148 5.33366 6.33329 5.33366C5.9651 5.33366 5.66663 5.63214 5.66663 6.00033V10.0003C5.66663 10.3685 5.9651 10.667 6.33329 10.667C6.70148 10.667 6.99996 10.3685 6.99996 10.0003V6.00033ZM10.3333 6.00033C10.3333 5.63214 10.0348 5.33366 9.66663 5.33366C9.29844 5.33366 8.99996 5.63214 8.99996 6.00033V10.0003C8.99996 10.3685 9.29844 10.667 9.66663 10.667C10.0348 10.667 10.3333 10.3685 10.3333 10.0003V6.00033Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10 0.833008C4.93743 0.833008 0.833374 4.93706 0.833374 9.99967C0.833374 15.0623 4.93743 19.1663 10 19.1663C15.0627 19.1663 19.1667 15.0623 19.1667 9.99967C19.1667 4.93706 15.0627 0.833008 10 0.833008ZM8.75004 7.49967C8.75004 7.03944 8.37695 6.66634 7.91671 6.66634C7.45647 6.66634 7.08337 7.03944 7.08337 7.49967V12.4997C7.08337 12.9599 7.45647 13.333 7.91671 13.333C8.37695 13.333 8.75004 12.9599 8.75004 12.4997V7.49967ZM12.9167 7.49967C12.9167 7.03944 12.5436 6.66634 12.0834 6.66634C11.6231 6.66634 11.25 7.03944 11.25 7.49967V12.4997C11.25 12.9599 11.6231 13.333 12.0834 13.333C12.5436 13.333 12.9167 12.9599 12.9167 12.4997V7.49967Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7991_165777)">
        <path d="M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6ZM4.25 7.5V4.5C4.25 4.22386 4.47386 4 4.75 4C5.02614 4 5.25 4.22386 5.25 4.5V7.5C5.25 7.77614 5.02614 8 4.75 8C4.47386 8 4.25 7.77614 4.25 7.5ZM6.75 7.5V4.5C6.75 4.22386 6.97386 4 7.25 4C7.52614 4 7.75 4.22386 7.75 4.5V7.5C7.75 7.77614 7.52614 8 7.25 8C6.97386 8 6.75 7.77614 6.75 7.5ZM11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_7991_165777">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7991_165778)">
        <path d="M14 8.00033C14 4.68662 11.3137 2.00033 7.99996 2.00033C4.68625 2.00033 1.99996 4.68662 1.99996 8.00033C1.99996 11.314 4.68625 14.0003 7.99996 14.0003C11.3137 14.0003 14 11.314 14 8.00033ZM5.66663 10.0003V6.00033C5.66663 5.63214 5.9651 5.33366 6.33329 5.33366C6.70148 5.33366 6.99996 5.63214 6.99996 6.00033V10.0003C6.99996 10.3685 6.70148 10.667 6.33329 10.667C5.9651 10.667 5.66663 10.3685 5.66663 10.0003ZM8.99996 10.0003V6.00033C8.99996 5.63214 9.29844 5.33366 9.66663 5.33366C10.0348 5.33366 10.3333 5.63214 10.3333 6.00033V10.0003C10.3333 10.3685 10.0348 10.667 9.66663 10.667C9.29844 10.667 8.99996 10.3685 8.99996 10.0003ZM15.3333 8.00033C15.3333 12.0504 12.05 15.3337 7.99996 15.3337C3.94987 15.3337 0.666626 12.0504 0.666626 8.00033C0.666626 3.95024 3.94987 0.666992 7.99996 0.666992C12.05 0.666992 15.3333 3.95024 15.3333 8.00033Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_7991_165778">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7991_165779)">
        <path d="M17.5 9.99967C17.5 5.85754 14.1422 2.49967 10 2.49967C5.85791 2.49967 2.50004 5.85754 2.50004 9.99967C2.50004 14.1418 5.85791 17.4997 10 17.4997C14.1422 17.4997 17.5 14.1418 17.5 9.99967ZM7.08337 12.4997V7.49967C7.08337 7.03944 7.45647 6.66634 7.91671 6.66634C8.37695 6.66634 8.75004 7.03944 8.75004 7.49967V12.4997C8.75004 12.9599 8.37695 13.333 7.91671 13.333C7.45647 13.333 7.08337 12.9599 7.08337 12.4997ZM11.25 12.4997V7.49967C11.25 7.03944 11.6231 6.66634 12.0834 6.66634C12.5436 6.66634 12.9167 7.03944 12.9167 7.49967V12.4997C12.9167 12.9599 12.5436 13.333 12.0834 13.333C11.6231 13.333 11.25 12.9599 11.25 12.4997ZM19.1667 9.99967C19.1667 15.0623 15.0627 19.1663 10 19.1663C4.93743 19.1663 0.833374 15.0623 0.833374 9.99967C0.833374 4.93706 4.93743 0.833008 10 0.833008C15.0627 0.833008 19.1667 4.93706 19.1667 9.99967Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_7991_165779">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconPauseCircle: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"pause-circle"} {...props} />
);
